const ApiConstants = {
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:3000/',
  ROOT_URL: process.env.REACT_APP_ROOT_URL || 'http://localhost:3001',
  WP_ROOT_URL: process.env.REACT_APP_WP_ROOT_URL ||'https://afriterra.org'
};
module.exports = ApiConstants;
